import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { fetchBatches, selectBatches } from "../features/store/product-batch/product-batch.slice";

const useProductBatches = (productId: number) => {
    const dispatch = useAppDispatch();
    const productBatches = useAppSelector(selectBatches);

    const getproductBatches = async () => {
        await dispatch(fetchBatches(productId));
    }

    useEffect(() => {
        // if (productBatches.length === 0) {
            getproductBatches();
        // }
    }, []);

    return [productBatches];
}
 
export default useProductBatches;